const CartProcessStep = {
    CART: 1,
    DELIVERY: 2,
    SENDER: 3,
    PAYMENT: 4
}

export default CartProcessStep